import { render, staticRenderFns } from "./ElectromagneticVehicle.vue?vue&type=template&id=5f7a43b4&scoped=true&"
import script from "./ElectromagneticVehicle.vue?vue&type=script&lang=js&"
export * from "./ElectromagneticVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a43b4",
  null
  
)

export default component.exports